export function convertData(data: any): object[] {
  const returnValue: object[] = [];
  for (const [key, value] of Object.entries(data))
    returnValue.push({ ...(value as object), id: key });
  return returnValue;
}
